import { AudioEnhancerTool } from '@/components/AudioEnhancerTool';

const AudioEnhancerPage = () => {
  return <AudioEnhancerTool />;
};

export default AudioEnhancerPage;
